import type { CSSProperties } from "react";

export const stickyBottomBarFirstTriggerStyles: CSSProperties = { position: "absolute", top: "500px" };
